import { Data } from '@mdqx/types/dist/proto/leadApp/data';
import { GetTimeFromTimestamp, LinkActivity as LeadAppLinkActivity } from '@mdqx/types';

export enum LeadAppLinkActivityStatusEnum {
    FILEDOWNLOADED = "FILEDOWNLOADED",
    LINKSAVED = "LINKSAVED",
    LINKSUBMITTED = "LINKSUBMITTED",
    DATATRANSFERRED = "DATATRANSFERRED",
    LINKOPENED = "LINKOPENED",
    LINKSAVEDFROMDAVE = "LINKSAVEDFROMDAVE",
    SELECTEDDATASAVED = "SELECTEDDATASAVED"
}

export const LeadAppLinkActivityStatusTypeNames: Map<LeadAppLinkActivityStatusEnum, string> = new Map<LeadAppLinkActivityStatusEnum, string>([
    [LeadAppLinkActivityStatusEnum.FILEDOWNLOADED, 'Vertrag gedownloaded'],
    [LeadAppLinkActivityStatusEnum.LINKSAVED, 'Formular gespeichert'],
    [LeadAppLinkActivityStatusEnum.LINKSUBMITTED, 'Formular abgeschickt'],
    [LeadAppLinkActivityStatusEnum.DATATRANSFERRED, 'Daten in Stammdaten übernommen'],
    [LeadAppLinkActivityStatusEnum.LINKOPENED, 'Link geöffnet'],
    [LeadAppLinkActivityStatusEnum.LINKSAVEDFROMDAVE, 'Formular von Admin gespeichert'],
    [LeadAppLinkActivityStatusEnum.SELECTEDDATASAVED, 'Selektierte Daten in Stammdaten übernommen'],
]);

export class LeadAppLinkActivityEntity {
    constructor(
        public Id: number = null,
        public LinkId: number = null,
        public Timestamp: Date = null,
        public ActivityType: LeadAppLinkActivityStatusEnum | null = null,
        public Username?: string,
        public UserRole?: string,
        public DocumentId?: string,
        public UserAgent?: string,
        public UserCity?: string,
        public UserMail?: string,
        public TextCheckBox1?: string,
        public TextCheckBox2?: string,
        public TextCheckBox3?: string,
        public TextCheckBox4?: string,
        public TextCheckBox5?: string,
        public Changes?: string,
    ) {}

    public static EntityName = 'LeadAppLinkActivity';

    public Clone(override: Partial<LeadAppLinkActivityEntity> = {}): LeadAppLinkActivityEntity {
        const attr = { ...this, ...override };
        return Object.assign(new LeadAppLinkActivityEntity(), attr);
    }
}

export function LeadAppLinkActivityEntityFromBackend(res: LeadAppLinkActivity): LeadAppLinkActivityEntity {
    const statusEnumValue = res.ActivityType ? LeadAppLinkActivityStatusEnum[res?.ActivityType] : null;

    return new LeadAppLinkActivityEntity(
        res.Id && +res.Id,
        res.LinkId && +res.LinkId,
       res.Timestamp && GetTimeFromTimestamp(+res.Timestamp),
        statusEnumValue,
        res.Username,
        res.UserRole,
        res.DocumentId,
        res.UserAgent,
        res.UserCity,
        res.UserEmail,
        res.TextCheckBox1,
        res.TextCheckBox2,
        res.TextCheckBox3,
        res.TextCheckBox4,
        res.TextCheckBox5,
        res.Changes,
    );
}
